const ProfileShare = {
  data() {
    return {
      webProfileCopied: false,
      emailProfileCopied: false,
    };
  },
  computed: {
    ...Vuex.mapState(['profile']),
    urlProfile() {
      return this.profile._id
        ? `https://www.domestiko.com/directorio/${this.profile._id}/`
        : '';
    },
    webProfile() {
      return this.profile._id
        ? `<a href="${this.urlProfile}?utm_source=Domestiko&utm_medium=profiles&utm_campaign=badge"><img src="https://www.domestiko.com/assets/img/banners/c360v1.png" alt="${this.profile.display_name}"></a>`
        : '';
    },
    emailProfile() {
      if (!this.profile._id) return;

      const avatar = this.profile.avatar
        ? `<td style="border-radius: 50%; overflow: hidden; width: 120px; height: 120px; vertical-align: middle; background: url(${this.profile.avatar.url}) no-repeat center center / cover">&nbsp;</td>`
        : '';
      let socials = '';
      if (this.profile.url) {
        socials += `<a href="${this.profile.url}" target="_blank"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEsSURBVDhPpZPRjcJADETZSg4qIVQC6SL5gvtKukioBKgEqCQ3z9jRXpAggkirzdresWfsTYvJ1zTNUqZdSmmtvdC6xRqG4beua87jl/KDLh90cSsbIGe/GCE7zgI5CuQQxhGgbdsTRrIIpKuqagWgB/aynfABTnXyb/AZgAIpeYsRIM/SBwAZI0a+UrF77XfsCc4yXHMqM/+hswEA3j/KXuq/AD3KyysA1KtDyHP4koydkC4yUrKpD5hTMw1CtEmsJQPgCmcT5NE6hLy8O1O1YoqPATyBVWDtcV5jN2ZQMLomYvCcISJ0S5K5Hvdv2ohWq3yQTP03g/QUk49yFx3wWRhHmTZ6txhz3sri3yjH5L14TEveAMsFN92sE9Ox9dHe+4VC+43ls9FPn/Mfl6EeUKfjGpAAAAAASUVORK5CYII=" alt="web"></a>&nbsp;`;
      }
      if (this.profile.linkedin) {
        socials += `<a href="${this.profile.linkedin}" target="_blank"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC0SURBVDhP3ZPbDcMgDEVhk2STdpNkC/hq+gVblE3aTcom9B6JVFGR+kjyVUuWDMYHP8DGGC/GmEG6RpIVoKyJnGNeAVmO7hfgEpCcc2MIobPW3r+F7Arg0m0llFLOUChB9ijzJj3QF+/9RHlMTP5T00SCOYSDyUiOWgNoRP5rBZtnD94B6qizmtxDUybTnMVHgA6TMo/N6JJeWeXl3j8B6sh4B8ggTdVmdIwSafZ2+UybvvMDjvLNwaOUz+4AAAAASUVORK5CYII=" alt="web"></a>&nbsp;`;
      }
      if (this.profile.twitter) {
        socials += `<a href="https://x.com/${this.profile.twitter}" target="_blank"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEkSURBVDhPjZPdbcMwDIStTZxNnEmSbGE/NXmyt6g7SbxJtIl7nyAGDK0CFSBAP7zT8UileZ6HLoxpmrZ4ZnvF91ozO+KSDq4ppe8AWMdxvEUSwIp9cb7v+00Ea2KzLAsEVw7ZQ6j1QwF3T6K4p/aDvysElZnLTi+fKiGBvFLSMbCWm2LORlwIHAnyVl6QCk9YXo7gotZLND8ggKjmm7XuNTPqfPyBoCq5C3ipfmBaMVj7k9KB7GN8KHCpAOoFIleqVAhb5T0QBD82gFVF/68UIHCOI937ceiPVgp48IVpAv9EP2J/NKtQwTRVNvl/+eH7YLDaE2yG+SbjPPphndgEW734cJBXP0xV8YPPdPggsdauP/DmPUrHuu+ZW43iVNCNTD/yLyJL2Ntt/NeFAAAAAElFTkSuQmCC" alt="web"></a>&nbsp;`;
      }

      return `<table style="width: 100%">
        <tr>
          ${avatar}
          <td style="padding-left: 20px">
                <p style="margin: 5px 0; vertical-align: middle; font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:16px;font-weight:bold;line-height:1;text-align:left;color:#000000;">${this.profile.first_name} ${this.profile.last_name}</p>
                <p style="margin: 5px 0; font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:12px;font-weight:normal;line-height:1;text-align:left;color:#000000;">${this.profile.user.email}</p>
                <p style="margin: 10px 0 5px; height:1px; background: #c3063e"></p>
                <p style="margin: 5px 0;"><a href="${this.urlProfile}?utm_source=Domestiko&utm_medium=profiles&utm_campaign=signature" target="_blank" style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:12px;font-weight:normal;line-height:1;text-align:left;color:#0d3479;">Ver mi perfil en Doméstiko</a></p>
                <p style="margin: 5px 0;">${socials}</p>
            </td>
        </tr>
    </table>`;
    },
  },
  methods: {
    copyToClipboard(key, type = 'text/plain') {
      const content = new ClipboardItem({
        [type]: new Blob([this[key]], { type }),
      });
      navigator.clipboard.write([content]).then(
        () => {
          const kid = `${key}Copied`;
          this[kid] = true;
          setTimeout(() => (this[kid] = false), 2000);
        },
        (err) => {
          console.error(`No se ha podido copiar ${key} al portapapeles`, err);
        },
      );
    },
  },
  template: `
    <div class="uk-margin-large-bottom">
      <h3 class="uk-margin-top">Ver tu perfil público</h3>
      <p>A través de este enlace puedes ver y compartir tu perfil público:</p>
      <p>
        <a :href="urlProfile" target="_blank">{{ urlProfile }}</a>
      </p>

      <h3 class="uk-margin-medium-top">Comparte tu perfil</h3>
      <p>
        ¡Haz que tu perfil brille aún más! Añade nuestra insignia en tu web y muestra a todos que formas parte de
        Doméstiko.
        <br>
        Solo tienes que incluir este enlace directo a tu perfil ¡Gracias por ayudarnos a crecer juntos!
      </p>
      <div uk-grid v-if="profile._id" class="uk-margin-medium-top">
        <div class="uk-text-center">
          <div v-html="webProfile"></div>
        </div>
        <div class="uk-width-1-1 uk-width-expand@m">
          <textarea class="uk-textarea" rows="6" style="word-break: break-all" disabled readonly
                    :value="webProfile"></textarea>
          <div class="uk-text-right uk-margin-small-top">
            <span v-if="webProfileCopied" class="uk-text-success">Código copiado correctamente</span>
            <button class="uk-button" @click="copyToClipboard('webProfile', 'text/html')">Copiar insignia</button>
            <button type="button" class="uk-button" style="padding: 0 10px;border-left: solid 1px #ddd;"><span
              uk-drop-parent-icon></span></button>
            <div uk-drop="mode: click; pos: bottom-right; offset: 0px">
              <button class="uk-button" @click="copyToClipboard('webProfile')">Copiar código HTML</button>
            </div>
          </div>
        </div>
      </div>


      <h3 class="uk-margin-medium-top">Consigue tu firma de correo electrónico</h3>
      <div v-html="emailProfile"></div>
      <div class="uk-margin-small-top">
        <button class="uk-button" @click="copyToClipboard('emailProfile', 'text/html')">Copiar firma</button>
        <button type="button" class="uk-button" style="padding: 0 10px;border-left: solid 1px #ddd;"><span
          uk-drop-parent-icon></span></button>
        <div uk-drop="mode: click; offset: 0px">
          <button class="uk-button" @click="copyToClipboard('emailProfile')">Copiar código HTML</button>
        </div>
        <span v-if="emailProfileCopied" class="uk-text-success">Código copiado correctamente</span>
      </div>
    </div>
  `,
};
